(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["de-destination-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const bar = form.closest('.de-destination-bar');
    const productRegion = bar?.dataset.deProductRegion;
    const counterpartUrl = bar?.dataset.deCounterpartUrl;
    if (!productRegion || !counterpartUrl) return;
    const country = form.querySelector('select[name="country_code"]')?.value;
    const returnTo = form.querySelector('input[name="return_to"]');
    if (!country || !returnTo) return;
    const destinationRegion = country === 'US' ? 'us' : 'eu';
    returnTo.value = destinationRegion === productRegion
      ? window.location.pathname + window.location.search
      : counterpartUrl;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
